/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {forwardRef} from 'react';
import RadioButton from '../radio/RadioButton';

interface GroupChooserRadioItemProps {
  label: string;
  value?: string;
}

/**
 * @GroupChooserRadioItem
 *
 * Radio Item that intentionally stops click propagation so that it can be
 * nested inside another clickable component like an accordion. Abstracted
 * mainly to prevent code duplication.
 *
 * ```typescript
 * import {GroupChooserRadioItem} from '@ion/dls/src/components/groupchooser';
 *
 * <GroupChooserRadioItem label='Choose me' />
 *
 * ```
 *
 * @param label radio label
 * @param value value of the radio item
 */
export const GroupChooserRadioItem = forwardRef(({label, value}: GroupChooserRadioItemProps, ref) => {
  return (
    <RadioButton label={label} value={value ?? label}
      ref={ref}
      onClick={function(event) { event.stopPropagation(); }}
      onFocus={function(event) { event.stopPropagation(); }} />
  );
});

export default GroupChooserRadioItem;
